import {
	Typography,
} from '@mui/material'
import type {
	JSX,
} from 'react'
import {
	memo,
} from 'react'

import type {
	IRadioGroupBlockOption,
} from '../types'
import {
	RadioGroupBlockItemCard,
	RadioGroupBlockItemContent,
	RadioGroupBlockItemImage,
} from './radio-group-block.styles'

interface IRadioGroupBlockItemProps {
	option:     IRadioGroupBlockOption
	onClick:    () => void
	isSelected: boolean
}

export const RadioGroupBlockItem = memo(({
	option,
	isSelected,
	onClick,
}: IRadioGroupBlockItemProps): JSX.Element => {
	return (
		<RadioGroupBlockItemCard
			onClick={onClick}
			variant='outlined'
			selected={isSelected}
		>
			{option.isSystem && option.image && (
				<RadioGroupBlockItemImage>
					<img
						src={option.image}
						alt={option.label}
					/>
				</RadioGroupBlockItemImage>
			)}
			<RadioGroupBlockItemContent>
				<Typography
					fontWeight={600}
					variant='body-x-small'
				>
					{option.label}
				</Typography>
				{option.description && (
					<Typography
						color='hint'
						variant='body-xxl-small'
					>
						{option.description}
					</Typography>
				)}
			</RadioGroupBlockItemContent>
		</RadioGroupBlockItemCard>
	)
})

RadioGroupBlockItem.displayName = 'RadioGroupBlockItem'
